import { render, staticRenderFns } from "./canadacheck.vue?vue&type=template&id=6fbf732f"
import script from "./canadacheck.vue?vue&type=script&lang=js"
export * from "./canadacheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports